var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTlos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.071 1.495a1.39 1.39 0 0 1 1.211-.487l5.445.58a1.39 1.39 0 0 1 1.194 1.747l-1.24 4.543 4.582 8.073c.18.32.229.697.133 1.05l-1.506 5.56a1.39 1.39 0 0 1-1.084 1.003c-.692.13-1.735.354-2.614.596a10.11 10.11 0 0 0-1.088.353c-.154.238-.339.454-.501.63a12.1 12.1 0 0 1-1.098 1.029c-.877.735-2.072 1.59-3.524 2.438-1.353.79-3.615 1.322-5.68 1.683-2.137.373-4.32.604-5.69.703a1.39 1.39 0 0 1-1.157-.481c-.922-1.077-2.546-4.185-3.217-9.175-.341-2.531-.275-4.594-.038-6.167.179-1.186.463-2.142.773-2.815L2.246 8.31a1.39 1.39 0 0 1 .433-1.273L6.5 3.562a1.39 1.39 0 0 1 .935-.361h9.2l1.436-1.705zm1.652 2.355-1.378 1.636a1.39 1.39 0 0 1-1.063.495H7.974L5.117 8.578l.675 3.76a1.39 1.39 0 0 1-.195.992c-.127.198-.45.925-.65 2.257-.195 1.297-.264 3.095.044 5.382.504 3.742 1.563 6.12 2.2 7.19a58.6 58.6 0 0 0 4.63-.605c2.1-.367 3.891-.84 4.76-1.346 1.329-.776 2.392-1.542 3.138-2.167.373-.314.653-.581.842-.785.15-.163.2-.24.202-.242.208-.465.594-.71.717-.788.196-.123.413-.223.608-.303a12.71 12.71 0 0 1 1.365-.445 35.406 35.406 0 0 1 1.977-.476l1.132-4.178-4.583-8.074a1.39 1.39 0 0 1-.133-1.052l.96-3.521-3.085-.33z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlos);
export default __webpack_public_path__ + "static/media/TLOS.acaaa87260605637ff4d89429af97bda.svg";
export { ForwardRef as ReactComponent };